export default __webpack_public_path__ + "static/media/smart-plug-theme.277f86ba.svg";